var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.refused)?_c('div',[_c('span',{staticClass:"pb-0.5 text-lg flex justify-center bg-red-600 w-8 h-8 rounded-full text-white"},[_vm._v("\n    ⚠\n  ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }